<capra-toast [type]="type" [inline]="true" [showCloseBtn]="showCloseBtn" [canTapToDismiss]="canTapToDismiss" (dismissToast)="dismissToast()">
  {{ message }}
</capra-toast>
